/*! ATOMGYM cart-shopify-sync.js — sync V-ULTIME custom cart (localStorage) to Shopify Ajax Cart at checkout time */
(function () {
  "use strict";

  var STORAGE_KEY = "atomgym_cart_v1";

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function colorFromItem(it) {
    if (it && it.color) return it.color;
    var n = ((it && it.name) || "").toLowerCase();
    if (n.indexOf("blanc") >= 0) return "blanc";
    if (n.indexOf("gris") >= 0) return "gris";
    return "noir";
  }

  function getVariantId(color, size) {
    var map = (window.ATOMGYM_VARIANTS || {})[color];
    return map ? map[size] : null;
  }

  function pushClear() {
    return fetch("/cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (r) {
      if (r.redirected && r.url.indexOf("/password") !== -1) throw new Error("PASSWORD_PROTECTION");
      // Don't fail on non-2xx clear; some Shopify configs return 200 with the empty cart
      return r.text().then(function (txt) {
        if (txt.indexOf("storefront-password-form") !== -1) throw new Error("PASSWORD_PROTECTION");
        return true;
      });
    });
  }

  function pushAdd(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) {
      if (r.redirected && r.url.indexOf("/password") !== -1) throw new Error("PASSWORD_PROTECTION");
      return r.text().then(function (txt) {
        var data = null;
        try { data = JSON.parse(txt); } catch (e) { data = null; }
        if (data === null) {
          // Real parse failure: not JSON
          if (txt.indexOf("/password") !== -1 || txt.indexOf("storefront-password-form") !== -1) {
            throw new Error("PASSWORD_PROTECTION");
          }
          throw new Error("ATOMGYM add — response non parsable (status " + r.status + "): " + txt.slice(0, 200));
        }
        // Parsed OK. Check Shopify business error shape.
        if (data.status && data.status >= 400) {
          throw new Error("ATOMGYM add — Shopify error " + data.status + ": " + (data.description || data.message || "unknown"));
        }
        if (!r.ok) {
          throw new Error("ATOMGYM add — HTTP " + r.status + ": " + (data.description || data.message || txt.slice(0, 200)));
        }
        // SUCCESS: Shopify returned the line item (or full cart)
        return data;
      });
    });
  }

  async function syncAndCheckout() {
    var items = readLocal();
    if (items.length === 0) {
      throw new Error("Le panier est vide.");
    }
    try {
      await pushClear();
    } catch (e) {
      console.error("[ATOMGYM] pushClear failed:", e);
      if ((e.message || "") === "PASSWORD_PROTECTION") throw e;
      throw new Error("Impossible de vider le panier Shopify (" + e.message + ")");
    }
    var successCount = 0;
    var failures = [];
    var passwordBlocked = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var color = colorFromItem(it);
      var size = it.size || "S";
      var vid = getVariantId(color, size);
      console.log("[ATOMGYM] item", i, { name: it.name, color: color, size: size, variant_id: vid, qty: it.qty });
      if (!vid) {
        console.error("[ATOMGYM] no variant_id for", { color: color, size: size, item: it });
        failures.push("Variant introuvable: " + (it.name || color) + " " + size);
        continue;
      }
      try {
        await pushAdd(vid, it.qty || 1);
        successCount++;
        console.log("[ATOMGYM] item synced OK", vid);
      }
      catch (e) {
        console.error("[ATOMGYM] push item failed:", it, e);
        if ((e.message || "") === "PASSWORD_PROTECTION") { passwordBlocked = true; break; }
        failures.push((it.name || color) + " " + size + ": " + (e.message || e));
      }
    }
    if (passwordBlocked) {
      throw new Error("PASSWORD_PROTECTION");
    }
    if (successCount === 0) {
      throw new Error("Aucun produit synchronisé. Détails dans la console.\n" + failures.join("\n"));
    }
    return { successCount: successCount, failures: failures };
  }

  // Intercept "Passer commande" / "Passer au paiement" CTA in cart drawer + main cart page
  document.addEventListener("click", function (e) {
    var cta = e.target.closest(".cart-drawer-cta, #cart-checkout-btn");
    if (!cta) return;
    e.preventDefault();
    var origText = cta.innerHTML;
    cta.style.pointerEvents = "none";
    cta.setAttribute("aria-busy", "true");
    cta.innerHTML = "Synchronisation...";
    syncAndCheckout()
      .then(function () { window.location.href = "/checkout"; })
      .catch(function (err) {
        console.error("[ATOMGYM] checkout sync error:", err);
        cta.style.pointerEvents = "";
        cta.removeAttribute("aria-busy");
        cta.innerHTML = origText;
        var msg = err && err.message ? err.message : String(err);
        if (msg === "PASSWORD_PROTECTION") {
          alert("Le store est en mode 'Mot de passe storefront' (Coming Soon). Les paniers ne peuvent pas être créés dans ce mode. Le merchant doit désactiver la protection par mot de passe pour autoriser les commandes.");
        } else {
          alert("Erreur de synchronisation du panier :\n\n" + msg + "\n\nDétails dans la console (F12).");
        }
      });
  });

  window.atomgymCartSync = {
    syncAndCheckout: syncAndCheckout,
    pushClear: pushClear,
    pushAdd: pushAdd,
    getVariantId: getVariantId,
    colorFromItem: colorFromItem
  };
})();
